module.exports = __webpack_public_path__ + "static/media/comments-selected.0147979f.png";